import './index.less'
import React from 'react'

const EmptyPlaceholder = ({ text }) => {
  return (
    <div className="empty-placeholder">
      <div className="img"></div>
      <div>
        <span>{text}</span>
      </div>
    </div>
  )
}

export default EmptyPlaceholder
